/** Copyright © 2013-2022 DataYes, All Rights Reserved. */

import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Loader from 'components/loader';
import storage from 'utils/localstorage';
import user from 'utils/user';
import { useQuery } from 'hooks/query';
import { getPermanentToken } from './service';

/**
 * @see {@link https://confluence.datayes.com/pages/viewpage.action?pageId=132413999|申港中台对接文档}
 * nginx 鉴权配置由运维部署在业务服务上层 nginx，而非服务自身的nginx配置中
 * 可以参考 configs/qa/nginx.conf 中的配置
 */
export default function PartnerAuth() {
  // ssoToken 为云平台提供的 cloud-sso-token
  const { ssoToken, isPermanent } = useQuery();
  const history = useHistory();
  const [isValidatedToken, setIsValidatedToken] = useState(true);

  const login = useCallback(
    (token) => {
      if (token) {
        storage.set('ssoToken', token);
      }

      user.init().then(({ anonymousUser }) => {
        if (anonymousUser) {
          setIsValidatedToken(false);
        } else {
          storage.set('isPartner', 1);
          history.replace('/');
        }
      });
    },
    [history]
  );

  useEffect(() => {
    // isPermanent 存在，需要用临时token换取一个永久token
    if (isPermanent && ssoToken) {
      getPermanentToken(ssoToken)
        .then(({ access_token }) => {
          login(access_token);
        })
        .catch(() => {
          setIsValidatedToken(false);
        });
    } else {
      login(ssoToken);
    }
  }, [isPermanent, login, ssoToken]);

  return isValidatedToken ? <Loader /> : <div>ssoToken 错误，请检查其有效性</div>;
}
